export const ProjectCategoryValidation = (formData) => {
    const errors = {};
  
    // Validate each field
  
    if (!formData.ProjectID.toString().trim()) {
      errors.ProjectID = 'This field is required';
    }
    if (!formData.CategoryName.toString().trim()) {
        errors.CategoryName = 'This field is required';
    } 
  
    return errors;
  };
  
 